import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/website-build/website-build/src/Layout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const Section = makeShortcode("Section");
const Image = makeShortcode("Image");
const SubTitle = makeShortcode("SubTitle");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Title mdxType="Title">Urban Blue Infrastructure</Title>
    <Section mdxType="Section">
  <Image src={'https://sjyurbanlab.github.io/website-assets/research-theme/urban-blue-infrastructure/urban-blue-infrastructure.jpg'} alt={'urban blue infrastructure'} size={'medium'} center mdxType="Image" />
    </Section>
    <Section mdxType="Section">
      <SubTitle mdxType="SubTitle">Reference</SubTitle>
      <p>{`Zhong Q, `}<strong parentName="p">{`Song J`}</strong>{`, Wang X, Zhang J, Zhang Q, Li Y (2026), `}<Link href={'https://doi: 10.1016/j.buildenv.2026.114319'} mdxType="Link">{`Modelling of lake–land breeze circulation in a diurnal cycle, `}<em parentName="p">{`Building and Environment`}</em>{`, 293, 114319.`}</Link></p>
      <p>{`Shi D, `}<strong parentName="p">{`Song J`}</strong>{`, Huang X, Chan PW (2025), `}<Link href={'https://doi: 10.1016/j.buildenv.2025.113096'} mdxType="Link">{`Modelling and optimization of urban green-blue infrastructure design for city cooling, `}<em parentName="p">{`Building and Environment`}</em>{`, 279, 113096.`}</Link></p>
      <p>{`Zhong Q, `}<strong parentName="p">{`Song J`}</strong>{`, et al (2025). `}<Link href={'https://doi: 10.1016/j.uclim.2025.102295'} mdxType="Link">{`Modeling of urban lake breeze circulation: Implications for the mitigation of urban overheating, `}<em parentName="p">{`Urban Climate`}</em>{`, 59, 102295.`}</Link></p>
      <p>{`Shi D, `}<strong parentName="p">{`Song J*`}</strong>{`, Zhong Q, Myint SW, Zeng P, Che Y (2024). `}<Link href={'https://www.sciencedirect.com/science/article/pii/S0034425723004777'} mdxType="Link">{`Cooling wisdom of ‘water towns’: How urban river networks can shape city climate? `}<em parentName="p">{`Remote Sensing of Environment`}</em>{`, 300, 113925.`}</Link></p>
    </Section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      